import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Global paywall interceptor — any 402 response navigates the user to /paywall
// unless the caller explicitly opts out with `{ skipPaywall: true }` in the request config
// (the floating chat handles its own in-panel paywall).
apiClient.interceptors.response.use(
  (res) => res,
  (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 402 && !cfg.skipPaywall) {
      const paywall = err.response.data?.detail?.paywall;
      if (paywall) {
        try {
          localStorage.setItem("mantrana_paywall", JSON.stringify(paywall));
        } catch (_) {
          /* ignore quota errors */
        }
      }
      try {
        localStorage.setItem("mantrana_free_chat_used", "true");
      } catch (_) {
        /* ignore */
      }
      if (typeof window !== "undefined" && window.location.pathname !== "/paywall") {
        window.location.href = "/paywall";
      }
    }
    return Promise.reject(err);
  }
);

function _readCookie(name) {
  if (typeof document === "undefined") return null;
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]+)"));
  return m ? decodeURIComponent(m[1]) : null;
}

function _writeCookie(name, value, days = 365) {
  if (typeof document === "undefined") return;
  document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${days * 86400}; path=/; SameSite=Lax`;
}

export function getSessionId() {
  // Read from BOTH cookie + localStorage so a refresh / cookie-clear / cache-clear
  // alone can't reset the free-reading credit.
  let sid = _readCookie("mantrana_sid") || localStorage.getItem("mantrana_session_id");
  if (!sid) {
    sid =
      (crypto.randomUUID && crypto.randomUUID()) ||
      `s-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  }
  // Re-write to both stores every time to refresh TTLs.
  localStorage.setItem("mantrana_session_id", sid);
  _writeCookie("mantrana_sid", sid);
  return sid;
}

export function saveBirthDetails(birth) {
  localStorage.setItem("mantrana_birth", JSON.stringify(birth));
  const key = computeProfileKey(birth);
  if (key) {
    localStorage.setItem("mantrana_profile_key", key);
    try {
      sessionStorage.setItem("mantrana_profile_key", key);
    } catch (_) {}
  }
}

export function getBirthDetails() {
  const raw = localStorage.getItem("mantrana_birth");
  return raw ? JSON.parse(raw) : null;
}

export function computeProfileKey(birth) {
  if (!birth) return "";
  const name = (birth.full_name || "").trim().toLowerCase().replace(/\s+/g, "");
  const dob = (birth.date_of_birth || "").trim();
  const tob = (birth.time_of_birth || "").trim();
  const place = (birth.place_of_birth || "")
    .trim()
    .toLowerCase()
    .replace(/,/g, " ")
    .split(/\s+/)
    .filter(Boolean)
    .join("_");
  const parts = [name, dob, tob, place].filter(Boolean);
  if (parts.length < 4) return "";
  return parts.join("_");
}

export function getProfileKey() {
  return (
    localStorage.getItem("mantrana_profile_key") ||
    (typeof sessionStorage !== "undefined"
      ? sessionStorage.getItem("mantrana_profile_key")
      : null) ||
    computeProfileKey(getBirthDetails())
  );
}

export function saveLastConsultationId(id) {
  localStorage.setItem("mantrana_last_consultation", id);
}

export function getLastConsultationId() {
  return localStorage.getItem("mantrana_last_consultation");
}
